module.exports = __webpack_public_path__ + "media/images/iconLockClosed-9b0e29ac21dc1cd17264e00cc2d43a45.png";